import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Returns the client portal token for the given brand, if one exists.
 * Used to show "Client Portal" link in Reports > PUBLIC PATH when the brand has portal access configured.
 */
export function useClientPortalToken(brandId: string | null) {
  const { data: token, isLoading } = useQuery({
    queryKey: ['clientPortalToken', brandId],
    queryFn: async (): Promise<string | null> => {
      if (!brandId) return null;
      const { data, error } = await supabase
        .from('brand_data')
        .select('client_portal_token, client_portal_enabled')
        .eq('brand_id', brandId)
        .single();
      if (error || !data?.client_portal_token) return null;
      if (data.client_portal_enabled === false) return null;
      return data.client_portal_token;
    },
    enabled: !!brandId,
  });

  return { token: token ?? null, isLoading };
}
